var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09427 2.86021C6.87417 3.30957 7.0526 3.85599 7.4928 4.08068C11.1882 5.96688 13.1622 7.80438 15.0024 11.1569C15.2895 11.68 15.2895 12.32 15.0024 12.8431C13.1622 16.1956 11.1882 18.0331 7.4928 19.9193C7.0526 20.144 6.87417 20.6904 7.09427 21.1399C7.31437 21.5891 7.84965 21.7713 8.28985 21.5466C12.264 19.5181 14.5216 17.441 16.5571 13.7325C17.1476 12.6569 17.1476 11.3431 16.5571 10.2675C14.5216 6.559 12.264 4.48185 8.28985 2.45338C7.84965 2.2287 7.31437 2.41084 7.09427 2.86021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-Right.d62cee6f.svg";
export { ForwardRef as ReactComponent };